var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanBiometric(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.692308,
    y: 0.692308,
    width: 70.6154,
    height: 70.6154,
    rx: 7.30769,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.692308,
    y: 0.692308,
    width: 70.6154,
    height: 70.6154,
    rx: 7.30769,
    stroke: "#8E8E8E",
    strokeWidth: 1.38462
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3088_4960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9225 60.9225H54.1025V58.0018H58.0018V54.1025H60.9225V60.9225Z",
    fill: "#DA0067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9978 17.897H11.0771V11.0771H17.897V13.9978H13.9978V17.897Z",
    fill: "#DA0067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.897 60.9225H11.0771V54.1025H13.9978V58.0018H17.897V60.9225Z",
    fill: "#DA0067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9225 17.897H58.0018V13.9978H54.1025V11.0771H60.9225V17.897Z",
    fill: "#DA0067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6209 35.0635V39.0261L21.376 41.608C18.5804 42.4792 16.7021 45.0319 16.7021 47.9603V54.1149H35.9457L40.3267 47.9947L35.9457 35.0636L30.6209 35.0635Z",
    fill: "#29CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5161 41.608L41.2711 39.0261V35.0635H35.9463V54.1148H55.1897V47.9602C55.1897 45.0319 53.3114 42.4793 50.5161 41.608Z",
    fill: "#00B1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0557 25.2798V28.1423C26.0557 33.5957 30.4925 38.0325 35.9458 38.0325L40.3269 27.7781L35.9458 15.3896C30.4925 15.3896 26.0557 19.8263 26.0557 25.2798Z",
    fill: "#45E6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8365 28.1423V25.2798C45.8365 19.8264 41.3997 15.3896 35.9463 15.3896V38.0325C41.3998 38.0325 45.8365 33.5957 45.8365 28.1423Z",
    fill: "#29CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9772 27.6346L33.3201 25.9775L31.2549 28.0427L34.9772 31.765L35.9466 30.7957L37.1493 28.8713L35.9466 26.6654L34.9772 27.6346Z",
    fill: "#00B1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8698 23.7422L35.9463 26.6658V30.7961L40.935 25.8074L38.8698 23.7422Z",
    fill: "#0091CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3088_4960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.8462,
    height: 49.8462,
    fill: "white",
    transform: "translate(11.0771 11.0771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanBiometric);
export default __webpack_public_path__ + "static/media/loanBiometric.d6179a338f8dd183f6dff15072e1bfb3.svg";
export { ForwardRef as ReactComponent };